module.exports = __webpack_public_path__ + "img/btn-pedopul@1x.4904df5e.png";